import { ReactNode, useState } from 'react'

interface TooltipProps {
  content: string
  children: ReactNode
  position?: 'top' | 'bottom' | 'left' | 'right'
}

export const Tooltip = ({
  content,
  children,
  position = 'top',
}: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  }

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={`absolute z-[1000] px-2 py-1 text-xs text-text bg-background-elevated border border-border-muted rounded shadow-lg whitespace-nowrap pointer-events-none ${positionClasses[position]}`}
          role="tooltip"
        >
          {content}
          <div
            className={`absolute w-2 h-2 bg-background-elevated border-r border-b border-border-muted ${
              position === 'top'
                ? 'top-full left-1/2 -translate-x-1/2 rotate-45 -mt-1'
                : position === 'bottom'
                ? 'bottom-full left-1/2 -translate-x-1/2 rotate-45 -mb-1'
                : position === 'left'
                ? 'left-full top-1/2 -translate-y-1/2 rotate-45 -ml-1'
                : 'right-full top-1/2 -translate-y-1/2 rotate-45 -mr-1'
            }`}
          />
        </div>
      )}
    </div>
  )
}
